import { getQuarter } from "date-fns";

import {
  ILicenseRequestApi,
  ILicenseRequestRow,
  LicenseRequestApiStatus,
  LicenseRequestRowActionType,
  LicenseRequestRowDecision,
  LicenseRequestRowStatus,
} from "~/entity/Licenses/model/schema";

const mapApiActionType = (
  actionType?: ILicenseRequestApi["actionType"],
): LicenseRequestRowActionType =>
  actionType === "BASE_ISSUE" ? "baseIssue" : "additional";

const mapApiStatusToRowStatus = (
  status: LicenseRequestApiStatus,
): LicenseRequestRowStatus => {
  if (status === "DRAFT") return "draft";

  if (status === "SENT") {
    return "pendingReview";
  }

  return "decided";
};

const mapApiDecisionToRow = (
  request: ILicenseRequestApi,
): LicenseRequestRowDecision | null => {
  if (request.status === "REJECTED" || request.decision === "REJECTED") {
    return "rejected";
  }

  if (request.status === "APPROVED" || request.decision === "ACCEPTED") {
    return "accepted";
  }

  return null;
};

export const mapLicenseRequestToRow = (
  request: ILicenseRequestApi,
): ILicenseRequestRow => {
  const createdAt = request.createdAt || request.requestDate || "";
  const updatedAt = request.updatedAt || request.reviewDate || createdAt;
  const year =
    request.year ?? (createdAt ? new Date(createdAt).getFullYear() : 0);
  const quarter =
    request.quarter ?? (createdAt ? getQuarter(new Date(createdAt)) : 0);
  const organization = request.dealerName || request.organizationName || "-";

  return {
    id: request.id,
    year,
    quarter,
    organization,
    inn: request.inn || "-",
    branchCode: request.branchCode || "-",
    actionType: mapApiActionType(request.actionType),
    status: mapApiStatusToRowStatus(request.status),
    decision: mapApiDecisionToRow(request),
    needsDecision: request.status === "SENT",
    createdAt: createdAt || undefined,
    updatedAt: updatedAt || undefined,
    author: request.authorName || "-",
    decisionUser: request.reviewerName || "-",
    comment: request.comment || undefined,
    dealerName: request.dealerName || request.organizationName || null,
  };
};
